import { render, staticRenderFns } from "./ShipmentDetailQuery.vue?vue&type=template&id=e0d1ca34&scoped=true"
import script from "./ShipmentDetailQuery.vue?vue&type=script&lang=js"
export * from "./ShipmentDetailQuery.vue?vue&type=script&lang=js"
import style0 from "./ShipmentDetailQuery.vue?vue&type=style&index=0&id=e0d1ca34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0d1ca34",
  null
  
)

export default component.exports